// FAQ for the home page (/pl). Also used to emit FAQPage JSON-LD (KROK 5).

export type FaqItem = { question: string; answer: string }

export const FAQ_ITEMS: FaqItem[] = [
  {
    question: 'Ile trwa realizacja projektu?',
    answer:
      'Rolki oddajemy w 48 h (Clean), 72 h (Dynamic) albo 96 h (Advanced) od zaksięgowania wpłaty, a dokładną datę i godzinę widzisz w panelu przy zamówieniu. Miniaturki i grafiki zwykle dostarczamy w ok. 20 godzin, montaż long-formów w ok. 72 godziny. Termin tych prac ustalamy na briefingu i trzymamy się go.',
  },
  {
    question: 'Jak wyglądają poprawki?',
    answer:
      'Każdy poziom ma policzoną liczbę rund poprawek — widać ją przy wyborze pakietu i zostaje zapisana na zamówieniu. Standardowo są to dwie rundy; po ich wykorzystaniu zlecenie zamykamy jako odebrane. Większy zakres ustalamy przed startem.',
  },
  {
    question: 'Jak wygląda płatność?',
    answer:
      'Całość z góry, przelewem online przez Przelewy24 — realizacja rusza po zaksięgowaniu. Fakturę VAT wystawiamy na żądanie: wystarczy podać dane firmy w kasie.',
  },
  {
    question: 'Czy otrzymuję prawa do gotowych materiałów?',
    answer:
      'Po opłaceniu zlecenia pełne prawa do gotowych materiałów przechodzą na Ciebie, możesz ich używać bez ograniczeń. Pliki źródłowe udostępniamy na życzenie.',
  },
  {
    question: 'Czy mogę wynająć studio lub zrealizować produkcję na miejscu?',
    answer:
      'Tak. Mamy w pełni wyposażoną przestrzeń do nagrań podcastów, wideo i sesji zdjęciowych, a produkcję realizujemy też u Ciebie lub w plenerze, z operatorem i sprzętem po naszej stronie. Dostępność i zakres ustalamy indywidualnie.',
  },
  {
    question: 'Czy współpraca wymaga stałej umowy?',
    answer:
      'Nie. Współpracę zaczynasz bez zobowiązań i możesz ją zakończyć z miesięcznym wyprzedzeniem. Umowa porządkuje zakres i zasady, nie wiąże Cię na siłę.',
  },
  {
    question: 'Z kim współpracuje FLOU?',
    answer:
      'Z twórcami, markami, firmami i przedsiębiorcami — od startujących kanałów po projekty z milionami wyświetleń i marki budujące obecność w social mediach. Zakres i tempo dopasowujemy do Twojej skali.',
  },
  {
    question: 'Czy mogę zamówić tylko jedną usługę?',
    answer:
      'Tak. Możesz zamówić jedną miniaturę, jeden montaż czy jedną sesję zdjęciową, bez pakietu i bez abonamentu. Wielu klientów zaczyna od jednego projektu i rozszerza zakres, kiedy zobaczy efekt.',
  },
  {
    question: 'Jak rozpocząć współpracę z FLOU?',
    answer:
      'Kliknij „Zacznij współpracę” albo napisz przez formularz kontaktowy. Wrócimy do Ciebie w 1–2 dni robocze z propozycją zakresu i wyceną.',
  },
]
